import React from 'react';

const dividerStyle = {
  opacity: 0.5,
  border: 0,
  borderColor: 'inherit',
  borderStyle: 'solid',
  borderBottomWidth: '1px',
  width: '100%',
  margin: '35px 0 25px 0',
};

const Divider = () => <hr style={dividerStyle} />

export default Divider;